/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 */
const SoldGiftVoucherResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'soldgiftvouchers/',
        Object.assign(
            apiRequestParams.defaults(),
            {
                resolve: () => 'giftvoucher,recipient',
            }
        ),
        {
            query: {
                isArray: true,
            },
            findByRef: {
                method: 'GET',
                isArray: true,
            },
        }
    );
};

module.exports = SoldGiftVoucherResource;
